<template>
    <span>
        <v-btn icon @click="requestDeleteConfirm()"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" :query-parameter="'confirmSpielPlanDelete'+item.id">
        </confirm-dialog>
    </span>
</template>

<script>
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import {db} from "../../services/db";
    import {firestore} from "../../services/db";

    export default {
        components: {
            ConfirmDialog},
        name: "spiel-plan-delete",
        props: ['item', 'saison'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
            itemTemp: null,
        }),
        methods: {
            requestDeleteConfirm(){
                this.confirmDelete.header = 'Spiel löschen';
                this.confirmDelete.question = "Möchtest du das Spiel '" + this.item.heim.teamName +
                    " : " + this.item.gast.teamName +
                    "' aus Runde " + this.item.rundeGroup +
                    " wirklich endgültig löschen?";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.itemTemp = JSON.parse(JSON.stringify(this.item));
                    this.deleteSpiel();
                }
                this.confirmDelete.open = false;
            },
            async deleteSpiel(){
                this.$store.state.local.loader = true;
                db.collection("spiele").doc(this.itemTemp.id).delete().then(() => {
                    this.updateSaison();
                }).catch((error) => {
                    console.error("Error removing document: ", error);
                });
            },
            async updateSaison(){
                this.saison.local.documentUpdates = {
                    ['spiele.' + this.itemTemp.id]: firestore.FieldValue.delete()
                };
                await this.saison.saveEdited('saison_edit');
                this.$store.dispatch('clearSnackbar');
                this.$store.state.local.loader = false;
                this.$store.state.globalSnack.text = 'Das Spiel wurde erfolgreich gelöscht';
                this.$store.state.globalSnack.color = 'success';
                this.$store.state.globalSnack.show = true;
                this.saison.local.documentUpdates = {};
            }
        },
    }

</script>

<style scoped>

</style>